import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import { Colors, Text } from "../../../config/Constants";
import Button from "../../Button";

const YachtClubRegistrationHeader = () => {
  const navigate = useNavigate();

  return (
    <StyledYachtClubHeader>
      <StyledPageHeader>{Text.yachtClubRegistrationHeader}</StyledPageHeader>
      <YachtClubRegistrationActions>
        <Button
          variant="filled"
          label={Text.parkingLayout}
          color={Colors.red}
          onClick={() => {
            navigate(`/admin/layout`);
          }}
        ></Button>
        <Button
          variant="filled"
          label={Text.berthTariff}
          color={Colors.red}
          onClick={() => {
            navigate(`/admin/berth-tariff`);
          }}
        ></Button>
      </YachtClubRegistrationActions>
    </StyledYachtClubHeader>
  );
};

const StyledYachtClubHeader = styled.div`
  display: flex;
  justify-content: space-between;
  padding-bottom: 1.25rem;
  @media only screen and (max-width: 1280px) {
    flex-direction: column-reverse;
  }
  @media only screen and (max-width: 768px) {
    padding: 1rem;
    padding-bottom: 0;
  }
`;

export const StyledPageHeader = styled.div`
  font-size: 1.25rem;
  font-family: "Poppins-Medium";
  line-height: 1.75rem;
  color: ${Colors.black};
  font-weight: 500;
  @media only screen and (max-width: 768px) {
    display: none;
  }
`;

const YachtClubRegistrationActions = styled.div`
  display: flex;
  align-items: center;
  width: 26rem;
  gap: 0.5rem;
  @media only screen and (max-width: 768px) {
    flex-direction: column;
    width: 100%;
  }
  @media only screen and (max-width: 1280px) {
    align-self: flex-end;
  }
`;

export default YachtClubRegistrationHeader;
